/* eslint-disable no-param-reassign, no-unused-vars */

import Vue from 'vue';
import axios from 'axios';
import AppModel from 'Models/AppModel';

const { API_URI } = AppModel;
const AUDIO_READY_STATE_DONE = 4;

let isAudioInited = false;

export default {
  state: () => ({
    notifications: [],
    audioElement: null,
    unread: {
      chats: {},
    },
  }),

  actions: {
    clearChatCounter({ commit }, id) {
      axios.post(`${API_URI}/order/counter/${id}/clear`).then(() => {
        commit('mutateClearUnreadByEntity', { entity: 'chats', id });
        commit('mutateRemoveNotification', `chats-${id}`);
      }).catch((error) => {
        throw new Error(error);
      });
    },

    getChatCounters({ commit }) {
      axios.get(`${API_URI}/order/counter/list`)
        .then(({ data }) => {
          if (data) {
            commit('mutateUnreadChats', data);
          }
        });
    },

    addSimpleNotification({ commit }, { notification }) {
      const entity = 'simple';
      const eventId = Date.now();
      commit('mutateAddNotification', { notification, entity, eventId });
    },

    initAudioNotification({ state }, audioElement) {
      if (!audioElement) {
        audioElement = state.audioElement;
      }

      /**
       * До того, как юзер не начнет взаимодествовать со страницей, на iOS/MacOS аудио не будет загружено.
       * Автоплэй так же заблокирован на системной уровне, т.е. пока юзер сам не запустит файл, из скрипта его воспроизвести не получится.
       * Но, если его воспроизвести из скрипна на нулевой громкости (не работает на iOS) или остановить сразу после воспроизведения, возможно дальнейшее воспроизведение из скрипта.
       */
      const events = ['click', 'touchstart'];

      events.forEach((event) => {
        window.addEventListener(event, () => {
          if (isAudioInited) {
            return;
          }

          audioElement.play();
          audioElement.pause();
          audioElement.currentTime = 0;
          isAudioInited = true;
        }, { once: true });
      });
    },

    playNotificationAudio({ state }, audioElement) {
      if (!audioElement) {
        audioElement = state.audioElement;
      }

      if (audioElement && audioElement.readyState === AUDIO_READY_STATE_DONE && audioElement.paused) {
        audioElement.play();
      }
    },
  },

  getters: {
    unreadChatsCount(state) {
      return +Object.keys(state.unread.chats).length;
    },

    unreadCountByEntityId: (state) => ({ id, entity }) => +state.unread[entity][id],
  },

  mutations: {
    mutateUnreadChats(state, chats) {
      state.unread.chats = chats;
    },

    mutateIncrementUnreadByEntity(state, { entity, id }) {
      if (state.unread[entity]) {
        if (!state.unread[entity][+id]) {
          state.unread[entity] = { ...state.unread[entity], [id]: 0 };
        }
        state.unread[entity][+id] = +state.unread[entity][+id] + 1;
      }
    },

    mutateClearUnreadByEntity(state, { entity, id }) {
      if (state.unread[entity] && state.unread[entity][+id]) {
        Vue.delete(state.unread[entity], id);
      }
    },

    mutateAddNotification(state, {
      entity, eventId, eventName, notification,
    }) {
      const notificationParent = {};

      notificationParent.id = notification.id || `${entity}-${eventId}`;

      const oldNotification = state.notifications
        .find((note) => note.id === notificationParent.id);

      if (oldNotification) {
        oldNotification.items.push(notification);
      } else {
        notificationParent.entity = entity;
        notificationParent.eventId = eventId;
        notificationParent.eventName = eventName;
        notificationParent.items = [notification];
        state.notifications.push(notificationParent);
      }
    },

    mutateRemoveNotification(state, notificationId) {
      state.notifications = state.notifications.filter((notification) => {
        if (notification.id === notificationId && Array.isArray(notification.items)) {
          // Выполняем hide функции, перед скрыванием нотификации
          notification.items.forEach((item) => {
            if (typeof item.notificationHideHandler === 'function') {
              item.notificationHideHandler();
            }
          });
        }

        return notification.id !== notificationId;
      });
    },

    mutateAudioElement(state, el) {
      state.audioElement = el;
    },
  },

  namespaced: true,
};
